import { render } from "./CreatePromoCodesModal.vue?vue&type=template&id=5b155f46&scoped=true&ts=true"
import script from "./CreatePromoCodesModal.vue?vue&type=script&lang=ts"
export * from "./CreatePromoCodesModal.vue?vue&type=script&lang=ts"

import "./CreatePromoCodesModal.vue?vue&type=style&index=0&id=5b155f46&scoped=true&lang=css"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b155f46"]])

export default __exports__